import { render, staticRenderFns } from "./BillingVirtualAccountBCA.vue?vue&type=template&id=4757e034"
import script from "./BillingVirtualAccountBCA.vue?vue&type=script&lang=js"
export * from "./BillingVirtualAccountBCA.vue?vue&type=script&lang=js"
import style0 from "./BillingVirtualAccountBCA.vue?vue&type=style&index=0&id=4757e034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports